import { useQuery } from "react-query";
import { fetchData } from "../api/client";

// Busca TUDO de uma vez no /clients/:id/details
export const useClientDetails = (id) => {
  return useQuery(
    ["client-details", id, "history-enriched"],
    () => fetchData(`/clients/${id}/details`, "GET"),
    {
      enabled: !!id,
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      select: (resp) => {
        // resp => { message, data: { client, requests, purchases, surveys } }
        return resp?.data || {};
      },
    }
  );
};
